<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Αργίες Σήμερα</h4>
            <p class="card-title-desc">
              Πίνακας που εμφανίζει τις σημερινές Αργίες
            </p>
            <!-- <b-tabs
              justified
              nav-class="nav-tabs-custom"
              content-class="p-3 text-muted"
            > -->
            <b-tabs content-class="p-3 text-muted">
              <b-tab active>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Αργίες Σήμερα</span>
                </template>
                <div class="col-xl-12">
                  <div class="table-responsive">
                    <table class="table mb-0">
                      <thead>
                        <tr>
                          <th>Α/Α</th>
                          <th>Ημερομηνία</th>
                          <th>Όνομα Αργιας</th>
                          <th>Σήμερα</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(holidayName, index) in publicHolidayToday" :key="index">
                          <th scope="row">
                            {{ index + 1 }}
                          </th>
                          <td>
                            {{ currentDate }}
                          </td>
                          <td>{{ holidayName }}</td>
                          <td>
                            <i class="bx bx-check-circle" style="color:green;font-size:17px;"></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-ellipsis-h"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Αργίες Όλου του χρόνου</span>
                </template>
                <div class="col-xl-12">
                  <div class="table-responsive">
                    <table class="table mb-0">
                      <thead>
                        <tr>
                          <th>Α/Α</th>
                          <th>Ημερομηνία</th>
                          <th>Όνομα Αργιας</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(holiday, index) in allHolidaysFromCurrentYear" :key="index">
                          <th scope="row">
                            {{ index + 1 }}
                          </th>
                          <td>
                            {{
                              holiday.date
                                .split("-")
                                .reverse()
                                .join("-")
                            }}
                          </td>
                          <td>{{ holiday.name }}</td>
                          <div v-if="is_staff">
                            <td v-show="canEditOrDeleteLocalHoliday(holiday.name)">
                              <i class="mdi mdi-pencil" @click.prevent="$bvModal.show(holiday.name)"></i>
                              <FormModal :bModal="{
                                id: holiday.name,
                                title: 'Επεξεργασία Αργίας',
                              }" :card="{
                                  title: 'Επεξεργασία Αργίας',
                                  description:
                                    'Συμπληρώστε την παρακάτω φόρμα και προσθέστε τοπική Αργία',
                                }" action="edit" @formData="parseFormData" :name="holiday.name"
                                :dateValue="currentDate" :errors="errors" :alert="alert" />

                              <i class="mdi mdi-trash-can" @click.prevent="confirm(holiday.name)"></i>
                            </td>
                          </div>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
        <button v-if="is_staff" class="btn btn-primary" @click.prevent="$bvModal.show('add-date')">
          <FormModal :bModal="{ id: 'add-date', title: 'Προσθήκη Αργίας' }" :card="{
            title: 'Προσθήκη Αργίας',
            description:
              'Συμπληρώστε την παρακάτω φόρμα και προσθέστε τοπική Αργία',
          }" action="add" @formData="parseFormData" :errors="errors" :alert="alert" />
          Προσθήκη Αργίας
        </button>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import session from "../../../api/session";
import FormModal from "./form-modal.vue";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import { eventCreate } from "../../../eventspy.js";

export default {
  page: {
    title: "Αργίες",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, FormModal },
  data() {
    return {
      title: "Αργιες",
      items: [
        {
          text: "Αρχική",
          to: { name: "home" },
        },
        {
          text: "Αργίες",
          active: true,
        },
      ],
      publicHolidayToday: [],
      currentDate: new Date().toLocaleString("gr", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }),
      allHolidaysFromCurrentYear: [],
      errors: null,
      alert: {},
      localHolidays: [],
    };
  },
  mounted() {
    this.fetchHolidayToday();
    this.fetchAllHolidaysFromCurrentYear();
    this.fetchLocalHolidaysFromApi();
  },
  computed: {
    ...mapGetters("auth", ["userLoggedIn", "is_staff"]),
  },
  methods: {
    async deletePublicHoliday(holidayId, holidayName) {
      eventCreate(`Διαγράφηκε η αργία ${holidayName}`, 3);
      await session
        .delete(`api/public-holidays/${holidayId}/delete/`)
        .then(() => {
          this.fetchHolidayToday();
          this.fetchAllHolidaysFromCurrentYear();
          this.fetchLocalHolidaysFromApi();
        })
        .catch((error) => console.log(error.response.data));
    },
    confirm(holidayName) {
      Swal.fire({
        title: "Είστε σίγουρος;",
        text: "Δεν θα μπορείτε να το επαναφέρετε!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ναι, διαγράψτε το!",
      }).then((result) => {
        if (result.value) {
          const localHolidayId = this.localHolidays.find(
            (e) => e.name == holidayName
          ).id;

          this.deletePublicHoliday(localHolidayId, holidayName);
          Swal.fire("Διαγράφηκε!", "Η αργία σας έχει διαγραφεί.", "success");
        }
      });
    },
    canEditOrDeleteLocalHoliday(holiday_name) {
      return (
        this.localHolidays.filter((e) => {
          return e.name == holiday_name;
        }).length > 0
      );
    },
    async fetchLocalHolidaysFromApi() {
      await session.get("api/public-holidays/local/").then((resp) => {
        this.localHolidays = resp.data;
      });
    },
    async fetchHolidayToday() {
      await session.get("api/public-holidays/").then((resp) => {
        this.publicHolidayToday = resp.data.detail;
      });
    },
    async fetchAllHolidaysFromCurrentYear() {
      await session.get("api/public-holidays/all-holidays/").then((resp) => {
        this.allHolidaysFromCurrentYear = resp.data.detail;
      });
    },
    datetimeToday() {
      const result =
        this.currentDate.getDate() +
        "-" +
        (this.currentDate.getMonth() + 1) +
        "-" +
        this.currentDate.getFullYear();
      return result;
    },

    async parseFormData(holidayDate, holidayName, action, oldHolidayName) {
      if (action === "add") {
        await session
          .post("api/public-holidays/add/", {
            name: holidayName,
            date_time: holidayDate,
          })
          .then(() => {
            this.alert = {
              alertVariant: "success",
              alertMsg: "Η αργία προστέθηκε επιτυχώς",
            };
            eventCreate(`Προστέθηκε η αργία ${holidayName}`, 1);
            this.fetchHolidayToday();
            this.fetchAllHolidaysFromCurrentYear();
            this.fetchLocalHolidaysFromApi();
            setTimeout(() => {
              this.alert = {};
              this.$bvModal.hide("add-date");
            }, 3000);
          })
          .catch((e) => {
            this.errors = e.response.data;
            this.alert = {
              alertVariant: "danger",
              alertMsg: `Υπήρξε πρόβλημα με: ${this.errors.name}`,
            };
            setTimeout(() => {
              this.alert = {};
              this.$bvModal.hide("add-date");
            }, 5000);
          });
      }
      if (action === "edit") {
        const localHolidayId = this.localHolidays.find(
          (e) => e.name == oldHolidayName
        ).id;
        await session
          .put(`api/public-holidays/${localHolidayId}/update/`, {
            name: holidayName,
            date_time: holidayDate,
          })
          .then(() => {
            this.alert = {
              alertVariant: "success",
              alertMsg: "Η αργία ανανεώθηκε επιτυχώς",
            };
            eventCreate(
              `Επεξεργασία αργίας ${oldHolidayName} σε ${holidayName}`,
              2
            );

            this.fetchHolidayToday();
            this.fetchAllHolidaysFromCurrentYear();
            this.fetchLocalHolidaysFromApi();
            setTimeout(() => {
              this.alert = {};
              this.$bvModal.hide(holidayName);
            }, 3000);
          })
          .catch((e) => {
            this.errors = e.response.data;
            this.alert = {
              alertVariant: "danger",
              alertMsg: `Υπήρξε πρόβλημα με: ${this.errors.name}`,
            };
            setTimeout(() => {
              this.alert = {};
              this.$bvModal.hide(holidayName);
            }, 5000);
          });
      }
    },
  },
};
</script>

<style scoped>
.mdi-pencil {
  padding: 10px;
  color: rgb(224, 151, 15);
  transition: all 0.4s;
  margin-right: 5px;
}

.mdi-trash-can {
  color: red;
  padding: 10px;
  transition: all 0.6s;
}

.mdi-pencil {
  color: rgb(224, 151, 15);
  cursor: pointer;
  font-size: 20px;
}

.mdi-trash-can {
  color: red;
  cursor: pointer;
  font-size: 20px;
}
</style>
